import { useState } from 'react';

import '../styles/global.css';

import PageHeader from '../components/general/pageHeader.js';
import PropertyTable from '../components/properties/propertyTable.js';
import MultiStepForm from '../components/forms/multiStepForm.js'

const Properties = () => {
    const [filterState, setFilterState] = useState(false);

    return (
        <div className="w-full">
            <PageHeader pageName="Units" />
            <MultiStepForm setFilterState={setFilterState} />
            <PropertyTable filterState={filterState} />
        </div>
    );

};

export default Properties;